module.exports = __webpack_public_path__ + "static/anthonycesnik-bba3ba0d36bf41b897d07afcbde7fe30.jpg";